import { BaseModel } from '../../_base/crud';

export class ContactRelationshipModel extends BaseModel {
  id: number;
  entity_type: string;
  relation_classification: string;
  first_name: string;
  last_name: string;
  relation_type_id;
  relation_type: string;
  relationship_description: string;
  created: Date;
  _isEditMode: boolean;
  entity_id: number;
  is_prime: boolean;
  financial_responsible: boolean;
  emergency_contact: boolean;
  phi_authorized: boolean;
  title: any;
  contact_id: number;
  valid_until_revoked: boolean;
  authorized_upto_date: Date;
  clear() {
    this.id = 0;
    this.entity_type = '';
    this.first_name = '';
    this.last_name = '';
    this.relation_type_id = '';
    this.relation_type = '';
    this.relationship_description = '';
    this.created = new Date();
    this._isEditMode = false;
    this.entity_id = 0;
    this.is_prime = false;
  }
}

export interface BillingContactResponse {
  status: number; // HTTP status code
  message: string; // Informative message
  billingContactId?: number; // Billing contact ID, optional for errors
  details?: any; // Additional details, optional for errors
}
